import { FaAngleDown, FaCartPlus } from "react-icons/fa";
import styles from "./cart.module.scss";
import { useState, useEffect } from "react";
import { MdDelete } from "react-icons/md";
import { useRouter } from "next/navigation";
import { useCookies } from "react-cookie";
import Cookies from "js-cookie";
import { FiAlertCircle } from "react-icons/fi";
import { CreatePaymentSession, whishPaymentInit } from "@services/paymentAPI";
import { getRowLabel } from "@utils/seatingUtils/drawingObjects/drawSection";
import { getRowLabelNew } from "@utils/seatingUtils/createMatrices";
import { sendGTMEvent } from '@next/third-parties/google'

export default function SeatingCart({
  selectedCircles,
  selectedTableCircles,
  TiersTypes,
  HoldTypes,
  seatingTickets,
  selectedArea,
  setSelectedArea,
  setSelectedCircles,
  setSelectedTableCircles,
  utm_source,
  eventID,
  seatingMapID,
  user,
  app,
  maxPerOrder,
  setMaxPerOrder,
  whish,
  redirectUrl,
  userIdentifier,
  objects,
  orgID,
  event,
  handleOpenPolicy
}) {
  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

  const [isExpanded, setIsExpanded] = useState(false);
  const [shake, setShake] = useState(false);
  const [showText, setShowText] = useState(false);
  const [loadingApp, setLoadingApp] = useState(false);
  const router = useRouter();
  const handleClick = () => {
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    if (
      selectedArea.length +
        selectedCircles.length +
        selectedTableCircles.length ===
      1
    ) {
      // setIsExpanded(true);
      setShake(true);
      if (isExpanded) {
        setTimeout(() => {
          setShowText(true);
        }, 400);
      } else {
        setShowText(false);
      }
    }
  }, [selectedCircles, selectedArea, selectedTableCircles]);

  useEffect(() => {
    if (isExpanded) {
      setTimeout(() => {
        setShowText(true);
      }, 400);
    } else {
      setShowText(false);
    }
  }, [isExpanded]);

  const findTier = (tierID) => {
    return TiersTypes.find((tier) => tier.TierID === tierID);
  };

  const findTicket = (tierID) => {
    return seatingTickets.find((tier) => tier.tierID === tierID);
  };
  const findTotal = () => {
    const allSeats = [...selectedCircles, ...selectedTableCircles];
    let totalPrice = 0;
    let curr = "";
    const find = allSeats.map((obj) => {
      const foundObject = seatingTickets.find(
        (ticket) => ticket.tierID === obj.TierID
      );
      return foundObject;
    });
    const findArea = selectedArea.map((obj) => {
      const foundObject = seatingTickets.find(
        (ticket) => ticket.tierID === obj.tierID
      );
      return { ...foundObject, quantity: obj.quantity };
    });
    find.map((p) => {
      curr = p?.currency;
      totalPrice += p?.sales[0]?.customerPrice;
    });
    findArea.map((p) => {
      if (find.length === 0) curr = p?.currency;
      totalPrice += p?.sales[0]?.customerPrice * p.quantity;
    });
    return `${totalPrice} ${curr}`;
  };
  const findCurr = () => {
    const allSeats = [...selectedCircles, ...selectedTableCircles];
    let totalPrice = 0;
    let curr = "";
    const find = allSeats.map((obj) => {
      const foundObject = seatingTickets.find(
        (ticket) => ticket.tierID === obj.TierID
      );
      return foundObject;
    });
    const findArea = selectedArea.map((obj) => {
      const foundObject = seatingTickets.find(
        (ticket) => ticket.tierID === obj.tierID
      );
      return { ...foundObject, quantity: obj.quantity };
    });
    find.map((p) => {
      curr = p?.currency;
      totalPrice += p?.sales[0]?.customerPrice;
    });
    findArea.map((p) => {
      if (find.length === 0) curr = p?.currency;
      totalPrice += p?.sales[0]?.customerPrice * p.quantity;
    });
    return `${curr}`;
  };
  const total = () => {
    const allSeats = [...selectedCircles, ...selectedTableCircles];
    let totalPrice = 0;
    let curr = "";
    const find = allSeats.map((obj) => {
      const foundObject = seatingTickets.find(
        (ticket) => ticket.tierID === obj.TierID
      );
      return foundObject;
    });
    const findArea = selectedArea.map((obj) => {
      const foundObject = seatingTickets.find(
        (ticket) => ticket.tierID === obj.tierID
      );
      return { ...foundObject, quantity: obj.quantity };
    });
    find.map((p) => {
      curr = p?.currency;
      totalPrice += p?.sales[0]?.customerPrice;
    });
    findArea.map((p) => {
      if (find.length === 0) curr = p?.currency;
      totalPrice += p?.sales[0]?.customerPrice * p.quantity;
    });
    return totalPrice;
  };
  const handleDeleteSectionSeat = (e, seatID) => {
    e.preventDefault();
    const updatedSelectedCircles = selectedCircles.filter(
      (seat) => seat.seatId !== seatID
    );
    setSelectedCircles(updatedSelectedCircles);
  };

  const handleDeleteTableSeat = (e, seatID) => {
    e.preventDefault();
    const updatedSelectedCircles = selectedTableCircles.filter(
      (seat) => seat.itemID !== seatID
    );
    setSelectedTableCircles(updatedSelectedCircles);
  };

  const handleDeleteAreaSeat = (e, seatID) => {
    e.preventDefault();
    const updatedSelectedCircles = selectedArea.filter(
      (seat) => seat.id !== seatID
    );
    setSelectedArea(updatedSelectedCircles);
  };

  const handleChangeQuantity = (e, item, type) => {
    e.preventDefault();
    const max = item.capacity - item.reservedCapacity;

setSelectedArea(prev =>
  prev.map(areaItem => {
    console.log(areaItem, item);
    
    if (areaItem.id !== item.id) return areaItem;

    const MIN = item.minPerOrder??1;
    console.log(item.minPerOrder);
    
    let rawNext;

    if (type === 'plus') {
      // first “plus” from anything under MIN jumps to MIN
      rawNext = areaItem.quantity < MIN ? MIN : areaItem.quantity + 1;
      console.log(areaItem.quantity, MIN , areaItem.quantity );
      
    } else {
      // minus just steps down by one
      rawNext = areaItem.quantity - 1;
    }
    console.log(rawNext);
    
    // clamp between MIN and max
    const nextQty = Math.min(max, Math.max(MIN, rawNext));
    console.log(nextQty, max);
    
    return {
      ...areaItem,
      quantity: nextQty,
    };
  })
);

  };
  const findTicketID = () => {
    let ticket;
    console.log(selectedArea, selectedCircles, selectedTableCircles);

    if (selectedCircles.length > 0) {
      ticket = findTicket(selectedCircles[0]?.TierID);
    } else if (selectedTableCircles.length > 0) {
      ticket = findTicket(selectedTableCircles[0]?.TierID);
    } else {
      ticket = findTicket(selectedArea[0]?.tierID);
    }
    return ticket;
  };
  const findQuantity = () => {
    const seatIds = selectedCircles.map((circle) => circle.seatId);
    const itemIds = selectedTableCircles.map(
      (tableCircle) => tableCircle.itemID
    );
    let areaQuantity = 0;
    selectedArea.map((a) => (areaQuantity += a.quantity));
    const seats = [...seatIds, ...itemIds];
    let ticket;
    if (selectedCircles.length > 0) {
      ticket = findTicket(selectedCircles[0]?.TierID);
    } else if (selectedTableCircles.length > 0) {
      ticket = findTicket(selectedTableCircles[0]?.TierID);
    } else {
      ticket = findTicket(selectedArea[0]?.tierID);
    }
    return seats.length + areaQuantity;
  }
  useEffect(() => {
    if(selectedArea.length === 0 && selectedCircles.length === 0 && selectedTableCircles.length === 0) return;
    // back gtm
    sendGTMEvent({ event: "add_to_cart",
      user_data: {
        country: user?.country ?? "",
        customer_id: user?.id ?? "", // user id
        email: user?.email ?? "",
        first_name: user?.fname ?? "",
        last_name: user?.lastName ?? "",
        phone: user?.phoneNumber ?? "",
     },
  ecommerce: {
    currency: findCurr,
    value: total(),
    items: [
    {
      item_id: findTicketID()?.ticketID, // ticketID // required
      item_name: findTicketID()?.name, // ticketName / /item_name
      price: total(),
      quantity: findQuantity(),
    }
    ]
  
    }});
  }, [selectedCircles, selectedTableCircles, selectedArea]);
  const [cookies, setCookies, removeCookies] = useCookies(["guestEmail"]);
  const [errorCheckOut, setErrorCheckOut] = useState("");
  const handleCheckOut = async () => {
    const seatIds = selectedCircles.map((circle) => circle.seatId);
    const itemIds = selectedTableCircles.map(
      (tableCircle) => tableCircle.itemID
    );
    const seats = [...seatIds, ...itemIds];
    const selectedAreas = selectedArea.map(({ id, quantity }) => ({
      areaID: id,
      quantity,
    }));
    let ticket;
    if (selectedCircles.length > 0) {
      ticket = findTicket(selectedCircles[0].TierID);
    } else if (selectedTableCircles.length > 0) {
      ticket = findTicket(selectedTableCircles[0].TierID);
    } else {
      ticket = findTicket(selectedArea[0].tierID);
    }
    const pricing = ticket.sales[0];
    let areaQuantity = 0;
    selectedAreas.map((a) => (areaQuantity += a.quantity));
    // console.log(areaQuantity, selectedAreas);
    const testItems = {
      waveID: "",
      quantity: seats.length + areaQuantity,
      basePrice: pricing.basePrice,
      serviceFees: pricing.serviceFees,
      customerPrice: pricing.customerPrice,
      waveName: "",
      maxPerOrder: ticket.maxPerOrder,
      currency: ticket.currency,
      ticketName: ticket.name,
      ticketID: ticket.ticketID,
      absorbFees: ticket.absorbFees,
      absorbPaymentFees: ticket.absorbPaymentFees,
      paymentOptions: ticket.ticketPaymentOptions,
      eventID: ticket.eventID,
      cashMapMain: {},
      cashMapAlt: {},
      holderRequiredData: ticket.holderRequiredData,
      isFree: false,
      continueAsGuest: false,
    };
    // console.log(testItems);
    if (app && !whish) {
      setLoadingApp(true);
    
      // Retrieve promoter data from localStorage
      let promoterParam = "";
      if (typeof window !== "undefined") {
        const savedPromoterData = localStorage.getItem("promoterData");
        if (savedPromoterData) {
          try {
            const promoterData = JSON.parse(savedPromoterData);
            // Check if the stored eventId matches the current eventID
            if (promoterData.eventId === eventID) {
              promoterParam = promoterData.promoter;
            }
          } catch (error) {
            console.error("Error parsing promoterData from localStorage", error);
          }
        }
      }
    
      try {
        // Pass promoterParam as the final argument (adjust according to your backend's parameter order)
        const { status, data } = await CreatePaymentSession(
          user.uid,
          "",
          "",
          eventID,
          "",
          0,
          "",
          seats ?? [],
          selectedAreas ?? [],
          seatingMapID ?? "",
          "co.tickit",
          promoterParam
        );
        // console.log(data);
        if (status === 200) {
          router.push("https://link.tickit.co/b1x");
        }
      } catch (error) {
        setErrorCheckOut(error.response.data.message);
        // console.error(error.response.data.message);
      }
      setLoadingApp(false);
      return;
    }
    
    if (!app && whish) {
      setLoadingApp(true);
      const whishReq = {
        eventID,
        seats: seats ?? [],
        areas: selectedAreas ?? [],
        seatingMapID: seatingMapID ?? "",
        userIdentifier,
      };
      
      try {
        const { status, data } = await whishPaymentInit(whishReq);
        // console.log(status, data);

        if (status === 200) {
          const absoluteUrl = new URL(
            `${redirectUrl}?sessionID=${data.data.sessionID}`,
            window.location.origin
          );
          window.location.href = absoluteUrl.href;
        }
      } catch (error) {
        // console.error(error);
        // setErrorCheckOut(error.response.data.message);
        // console.error(error);
        setLoadingApp(false);
      }
      setLoadingApp(false);
      return;
    } else {
      Cookies.set("testItems", JSON.stringify(testItems));
      setCookies("seats", seats, { path: "/" });
      setCookies("selectedAreas", selectedAreas, { path: "/" });
      setCookies("seatingMapID", seatingMapID, { path: "/" });
    
      // ⬇️ only touch sessionStorage when window exists
      if (typeof window !== "undefined") {
        sessionStorage.setItem("seats", seats);
        sessionStorage.setItem("selectedAreas", selectedAreas);
      }
     if(event && event?.doorPolicy){
      handleOpenPolicy("seatingMap");
     }
    else {
      const url = utm_source
        ? `/payment/${eventID}?utm_source=${utm_source}&is_seat=true`
        : `/payment/${eventID}?is_seat=true`;
    
      router.push(url);
    }
    }
  };

  const checkMaxPerOrder = () => {
    let getTicket = {};
    if (selectedCircles.length > 0)
      getTicket = findTicket(selectedCircles[0].TierID);
    if (selectedTableCircles.length > 0)
      getTicket = findTicket(selectedTableCircles[0].TierID);
    if (selectedArea.length > 0) getTicket = findTicket(selectedArea[0].tierID);
    const totalAreaSeats = selectedArea.reduce(
      (total, item) => total + item.quantity,
      0
    );
    const totalSectionSeats = selectedCircles.length;
    const totalTableSeats = selectedTableCircles.length;
    const totalSeats = totalAreaSeats + totalSectionSeats + totalTableSeats;
    if (totalSeats > getTicket.maxPerOrder) setMaxPerOrder(true);
    else setMaxPerOrder(false);

    // console.log(totalSeats > getTicket.maxPerOrder, maxPerOrder);
  };

  useEffect(() => {
    checkMaxPerOrder();
  }, [selectedCircles, selectedTableCircles, selectedArea]);
  let totalSelectNumber =
    selectedArea.reduce((total, item) => total + item.quantity, 0) +
    selectedCircles.length +
    selectedTableCircles.length;

  useEffect(() => {
    setTimeout(() => {
      setShake(false);
    }, 3000);
  }, [shake]);
  return (
    <div
      className={`${styles.cartButton}  ${isExpanded ? styles["extend"] : ""}`}
    >
      {isExpanded && <div className={styles.overlay}></div>}
      <div
        className={`${styles.cart} ${styles["fade-in"]} ${
          isExpanded ? styles["show"] : styles["notExpanded"]
        }`}
      >
        <div className={styles.cartHeader}>
          <h4>My Cart {`(${totalSelectNumber})`}</h4>{" "}
          <div onClick={handleClick}>
            <FaAngleDown />
          </div>
        </div>
        <div className={styles.itemsList}>
          {selectedCircles.map((item) => {
            function isNumber(value) {
              return typeof value === "number" && !isNaN(value);
            }
            function getLetterIndex(letter) {
              return alphabet.indexOf(letter.toUpperCase());
            }
            const startCheck = isNumber(item.startFrom);
            const valFromLetter = !startCheck
              ? getLetterIndex(item.startFrom)
              : item.startFrom;
          
              const obj = objects.filter((obj) => obj.id === item.objectId);
              let label = "";
              const validEventIDs = ["15M0Nzs6N5F62jFv4H2a", "DJOkf65ObMeo2jbQyb8v"];
              if(validEventIDs.includes(orgID)){
                console.log("Using new row label function", item.rowIndex);
                
               label = getRowLabelNew(
                item.rowIndex,
                obj[0].matrix.length,
                obj[0].isReversedRowLabel,
                obj[0].useRowLabelNumber,
                obj[0].startFrom
              );
              }
            else { 
                console.log("Using new row label function 1", item, selectedCircles);
              label = getRowLabel(
                item.rowIndex,
                obj[0].matrix.length,
                obj[0].isReversedRowLabel,
                obj[0].useRowLabelNumber,
                obj[0].startFrom
              );
            }
            return (
              <div
                key={item.seatId}
                className={styles.item}
                style={{
                  borderLeftColor: `${findTier(item.TierID).TierColor}`,
                }}
              >
                <div className={styles.itemType}>
                  {findTier(item.TierID)?.TierName}
                </div>
                <div className={styles.sub}>
                  <div className={styles.itemDetails}>
                    {item.sectionName.length > 0 && item.sectionName}{item.sectionName.length > 0 && ","} Row{" "}
                    {label}, Seat{" "}
                    {item.seatName}
                  </div>
                  <div className={styles.itemPrice}>
                    {findTicket(item.TierID)?.sales[0]?.customerPrice}{" "}
                    {findTicket(item.TierID)?.currency}
                  </div>
                </div>
                <div className={styles.sub}>
                  <div className={styles.itemDetails}>
                    {/* Details <FaAngleDown /> */}
                  </div>
                  <div
                    className={styles.itemDelete}
                    onClick={(e) => handleDeleteSectionSeat(e, item.seatId)}
                  >
                    <MdDelete />
                  </div>
                </div>
                {/* <button className={styles.detailsButton}>Details</button> */}
              </div>
            );
          })}
          {selectedTableCircles.map((item) => {
            return (
              <div
                key={item.itemID}
                className={styles.item}
                style={{
                  borderLeftColor: `${findTier(item.TierID).TierColor}`,
                }}
              >
                <div className={styles.itemType}>
                  {findTier(item.TierID)?.TierName}
                </div>
                <div className={styles.sub}>
                  <div className={styles.itemDetails}>
                    {item.tableName}, Seat {item.index}
                  </div>
                  <div className={styles.itemPrice}>
                    {findTicket(item.TierID)?.sales[0]?.customerPrice}{" "}
                    {findTicket(item.TierID)?.currency}
                  </div>
                </div>
                <div className={styles.sub}>
                  <div className={styles.itemDetails}>
                    {/* Details <FaAngleDown /> */}
                  </div>
                  <div
                    className={styles.itemDelete}
                    onClick={(e) => handleDeleteTableSeat(e, item.itemID)}
                  >
                    <MdDelete />
                  </div>
                </div>
                {/* <button className={styles.detailsButton}>Details</button> */}
              </div>
            );
          })}
          {selectedArea.map((item) => {
            // console.log(item);
            return (
              <div
                key={item.id}
                className={styles.item}
                style={{
                  borderLeftColor: `${item.tierColor}`,
                }}
              >
                <div className={styles.itemType}>
                  {findTier(item.tierID)?.TierName}
                </div>
                <div className={styles.sub}>
                  <div className={styles.itemDetails}>{item.name}</div>
                </div>
                <div className={styles.combineArea}>
                  <div className={styles.addTickets}>
                    <div>People: </div>
                    <button
                      className={styles.minus}
                      style={{
                        backgroundColor: `${item.tierColor}`,
                      }}
                      onClick={(e) => handleChangeQuantity(e, item, "minus")}
                    >
                      -
                    </button>
                    <div className={styles.reserved}>{item.quantity}</div>
                    <button
                      className={styles.plus}
                      style={{
                        backgroundColor: `${item.tierColor}`,
                      }}
                      onClick={(e) => handleChangeQuantity(e, item, "plus")}
                    >
                      +
                    </button>
                  </div>
                  <div className={styles.itemPrice}>
                    <span>
                      {findTicket(item.tierID)?.sales[0]?.customerPrice *
                        item.quantity}
                      {findTicket(item.tierID)?.currency}
                    </span>
                  </div>
                </div>

                <div className={styles.sub}>
                  <div className={styles.itemDetails}>
                    {/* Details <FaAngleDown /> */}
                  </div>
                  <div
                    className={styles.itemDelete}
                    onClick={(e) => handleDeleteAreaSeat(e, item.id)}
                  >
                    <MdDelete />
                  </div>
                </div>
                {/* <button className={styles.detailsButton}>Details</button> */}
              </div>
            );
          })}
        </div>
        <div
          className={styles.row}
          style={{
            alignItems: "center",
            display: "flex",
            justifyContent: "flex-start",
            opacity: "80%",
            height: "20px",
          }}
        >
          <FiAlertCircle /> &nbsp; <span>Excluding Service Fees</span>
        </div>

        <div className={styles.total}>
          Total: <span className={styles.totalPrice}>{findTotal()}</span>
        </div>
        {errorCheckOut.length > 0 && (
          <p style={{ color: "red", fontSize: "12px" }}> {errorCheckOut}</p>
        )}
        {/* <button className={styles.checkoutButton}>Checkout</button> */}
      </div>
      <div>
        {!isExpanded && (
          <div className={styles.totalCart}>{totalSelectNumber}</div>
        )}
        <button
          className={`${styles["circular-button"]} ${
            isExpanded ? styles["expanded"] : ""
          } ${shake ? styles["shake"] : ""}`}
          onClick={(e) => {
            e.preventDefault();
            isExpanded ? handleCheckOut() : handleClick(e);
          }}
          disabled={
            (showText &&
              isExpanded &&
              selectedArea.length === 0 &&
              selectedCircles.length === 0 &&
              selectedTableCircles.length === 0) ||
            (showText && isExpanded && maxPerOrder) ||
            loadingApp
          }
        >
          {showText && isExpanded ? "Checkout" : <FaCartPlus />}
        </button>
      </div>
    </div>
  );
}
